import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Compose des classes Tailwind en laissant la derniere gagner.
 *
 * `clsx` assemble les conditions, `twMerge` resout les conflits : sans lui,
 * `px-3` et `px-6` coexistent dans l'attribut et c'est l'ordre du fichier CSS
 * qui tranche, pas l'intention de l'appelant.
 */
export const cn = (...classes: ClassValue[]) => twMerge(clsx(classes))
